import Head from 'next/head';
import { PageProps } from './Page.interfaces';
import { IMeta } from '@/interfaces';
import { useRouter } from 'next/router';

import { getValidClassNames } from '@/utils';
import { environmentVariables } from '@/utils/environmentVariables';
import { Button, InfoIcon } from '@netfront/ui-library';

export const Page = ({ additionalClassNames, children, footer, header, meta, title }: PageProps) => {
  const router = useRouter();
  const { seoDescription: seoDescriptionProp, seoTitle: seoTitleProp } = meta ?? ({} as IMeta);

  const seoTitle = `${seoTitleProp ? seoTitleProp : title}`;
  const seoDescription = seoDescriptionProp ? seoDescriptionProp : seoTitleProp ? seoTitleProp : title;

  // Build canonical URL using Next.js router (works during SSR)
  const canonicalUrl = `${environmentVariables.baseUrl.replace(/\/$/, '')}${router.asPath}`;

  return (
    <>
      <Head>
        <title>{seoTitle}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
        <meta content={seoDescription} name="description" />
        <meta content={seoTitle} property="og:title" />
        <meta content={seoDescription} property="og:description" />
        <meta content="/logo-icon.jpg" property="og:image" />
        <link href={canonicalUrl} rel="canonical" />
        <link
          rel="stylesheet"
          href={`https://ekardo.s3.ap-southeast-2.amazonaws.com/production/project/${environmentVariables.projectId}/Css/allinone.min.css`}
        />
      </Head>
      <div
        className={getValidClassNames({
          'flex flex-col min-height-screen relative': true,
          [String(additionalClassNames)]: Boolean(additionalClassNames),
        })}
      >
        {header}

        <main className="flex flex-col flex-1 relative">
          <Button
            additionalClassNames="c-button--viewport kanzi-no-print"
            icon={InfoIcon}
            text="Get help now"
            linkButton={{ id: 'get-help-now', url: '/get-help-and-support' }}
            variant="accent"
          />
          {children}
        </main>

        {footer}
      </div>
    </>
  );
};
